export default __webpack_public_path__ + "static/media/merriweather.55c73e48.ttf";